<div class="calendar-wrapper p-20">
    <div class="header-actions" style="display: flex; flex-direction: column; gap: 15px; margin-bottom: 20px;">
        
        <!-- Top Row: Title, Date, and Navigation -->
        <div style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 15px;">
            <div style="display: flex; flex-wrap: wrap; align-items: baseline; gap: 15px;">
                <h2 style="margin: 0; white-space: nowrap;">Practitioner Schedule Calendar</h2>
                <h3 style="margin: 0; color: #666; font-weight: 400; white-space: nowrap;">
                    {{ viewDate | date: 'MMMM yyyy' }}
                </h3>
            </div>
            
            <div class="btn-group" style="display: flex; flex-wrap: nowrap; gap: 5px;">
                <button mat-button mwlCalendarPreviousView [view]="'week'" [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange()">
                    Previous
                </button>
                <button mat-flat-button color="primary" mwlCalendarToday [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange()">
                    Today
                </button>
                <button mat-button mwlCalendarNextView [view]="'week'" [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange()">
                    Next
                </button>
            </div>
        </div>

        <!-- Bottom Row: Remind and Assign -->
        <div style="display: flex; justify-content: flex-end; gap: 10px; flex-wrap: wrap;">
            <div *ngIf="reminderOptions.length" style="display: flex;">
                <button mat-stroked-button color="accent" [matMenuTriggerFor]="reminderMenu" type="button">
                    <mat-icon>notifications</mat-icon>
                    Remind
                    <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #reminderMenu="matMenu">
                    <button *ngFor="let item of reminderOptions" mat-menu-item (click)="sendReminder(item.intervalType, item.reasonType)">
                        {{ item.label }}
                    </button>
                </mat-menu>
            </div>
            <button mat-flat-button color="primary" (click)="assignOverrides()">
                <mat-icon>assignment_turned_in</mat-icon> Assign
            </button>
            <button mat-stroked-button color="warn" (click)="removeSelected()">
                <mat-icon>delete</mat-icon> Remove Selected
            </button>
            <button mat-stroked-button color="warn" (click)="forceRemoveSelected()">
                <mat-icon>dangerous</mat-icon> Force Remove & Cancel
            </button>
        </div>
    </div>

    <ng-template #customHourSegmentTemplate let-segment="segment" let-locale="locale" let-segmentHeight="segmentHeight" let-isTimeLabel="isTimeLabel">
            <div
                class="cal-hour-segment"
                [style.height.px]="segmentHeight"
                [class.cal-hour-start]="segment.isStart"
                [class.cal-after-hour-start]="!segment.isStart"
                [ngClass]="segment.cssClass"
                (pointerdown)="onPointerDown($event, segment.date)"
                (pointerenter)="onPointerEnter($event, segment.date)"
                style="position: relative;"
            >
        <div class="cal-time" *ngIf="isTimeLabel" style="pointer-events: none;">
          {{ segment.date | calendarDate:'weekViewHour':locale }}
        </div>
        
        <div *ngIf="segment.cssClass === 'cal-segment-existing-slot'" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #1e90ff; font-weight: bold; pointer-events: none;">
            ✔
        </div>
        
        <div *ngIf="segment.cssClass === 'cal-segment-selected'" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #2e7d32; font-weight: bold; font-size: 18px; pointer-events: none;">
            +
        </div>
      </div>
    </ng-template>

    <div class="calendar-container" #scrollContainer style="background: white; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.05);">
        <!-- Week View -->
        <mwl-calendar-week-view
            [viewDate]="viewDate"
            [events]="events"
            [refresh]="refresh"
            [dayStartHour]="0"
            [dayEndHour]="24"
            [hourSegmentTemplate]="customHourSegmentTemplate"
                (beforeViewRender)="beforeWeekViewRender($event)"
        >
        </mwl-calendar-week-view>
    </div>
</div>
